import './Skills.css';
import blenderIcon from '../../images/icons/icon_blender.png';
import csharpIcon from '../../images/icons/icon_csharp.png';
import elementorIcon from '../../images/icons/icon_elementor.png';
import figmaIcon from '../../images/icons/icon_figma.png';
import firebaseIcon from '../../images/icons/icon_firebase.png';
import gitIcon from '../../images/icons/icon_git.png';
import jiraIcon from '../../images/icons/icon_jira.png';
import javascriptIcon from '../../images/icons/icon_js.png';
import kritaIcon from '../../images/icons/icon_krita.png';
import materialIcon from '../../images/icons/icon_material.png';
import mayaIcon from '../../images/icons/icon_maya.png';
import officeIcon from '../../images/icons/icon_office.png';
import particleSystemsIcon from '../../images/icons/icon_particlesys.png';
import pythonIcon from '../../images/icons/icon_python.png';
import reactIcon from '../../images/icons/icon_react.png';
import substanceIcon from '../../images/icons/icon_substance.png';
import unityIcon from '../../images/icons/icon_unity.png';
import unrealIcon from '../../images/icons/icon_unreal.png';
import wordpressIcon from '../../images/icons/icon_wordpress.png';
import zbrushIcon from '../../images/icons/icon_zbrush.png';

const skillIcons = {
  Blender: blenderIcon,
  'C#': csharpIcon,
  Elementor: elementorIcon,
  Figma: figmaIcon,
  Firebase: firebaseIcon,
  'Git / GitHub': gitIcon,
  Jira: jiraIcon,
  JavaScript: javascriptIcon,
  Krita: kritaIcon,
  'Materials & Shaders': materialIcon,
  Maya: mayaIcon,
  'Microsoft Office': officeIcon,
  'VFX / Particle Systems': particleSystemsIcon,
  Python: pythonIcon,
  React: reactIcon,
  'Substance Painter': substanceIcon,
  Unity: unityIcon,
  'Unreal Engine': unrealIcon,
  WordPress: wordpressIcon,
  ZBrush: zbrushIcon,
};

function getInitials(label) {
  return label.split(/[\s/]+/).map((word) => word[0]).join('').slice(0, 2);
}

function Skills({ content }) {
  return (
    <section className="section skills" id="skills">
      <div className="section__content">
        <p className="eyebrow">{content.eyebrow}</p>
        <h2 className="section-title">{content.title}</h2>
        <div className="skills__grid">
          {content.categories.map((category) => (
            <article className="skill-group" key={category.title}>
              <h3>{category.title}</h3>
              <ul>
                {category.items.map((item) => {
                  const icon = skillIcons[item];

                  return (
                    <li key={item}>
                      <span className={`skill-group__icon${icon ? ' skill-group__icon--image' : ''}`} aria-hidden="true">
                        {icon ? <img src={icon} alt="" /> : getInitials(item)}
                      </span>
                      {item}
                    </li>
                  );
                })}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
